<script setup lang="ts">
import type { mastodon } from '#shared/types'

defineOptions({
  name: 'Tags',
})

const { id } = useRoute().params

const { data, pending } = await useFetch<mastodon.v1.Tag>(`/api/tags/${id}`)
const isLoggedIn = useAuth().loggedIn
</script>

<template>
  <div class="tag-page">
    <HeaderMain>
      <template #header-start>
        <SpinnerIcon v-if="pending" />
        <template v-else-if="data">
          <div v-if="data" class="tag-name">
            <span class="icon-hash big" />
            <h3>{{ data.name }}</h3>
          </div>
        </template>
      </template>
      <template #header-end>
        <TagAction v-if="isLoggedIn && data" :tag="data" />
      </template>
    </HeaderMain>
    <div class="tab-bar">
      <NuxtLink :to="{ name: 'tags-id', params: { id } }">
        {{ $t('tab-posts') }}
      </NuxtLink>
      <NuxtLink :to="{ name: 'tags-id-profiles', params: { id } }">
        {{ $t('tab-accounts') }}
      </NuxtLink>
    </div>
    <NuxtPage />
  </div>
</template>

<style>
.tag-page {
  .tab-bar {
    display: flex;
    gap: var(--padding-base);
    padding-inline: var(--padding-base);
    border-bottom: 1px solid var(--color-border);
    margin-bottom: var(--padding-big);

    a {
      color: var(--color-text);
      text-decoration: none;
      padding: var(--padding-small) var(--padding-base);
      &.router-link-exact-active {
        background-color: var(--color-panel-minor);
      }
    }
  }
}
.tag-name {
  padding-inline: var(--padding-base);
  display: flex;
  align-items: center;
  gap: var(--padding-mini);
}
</style>
